(function () {
  const DURATION = 9 * 60; // 9 minutos en segundos
  const STORAGE_KEY = "timer_end_v1";
  const timerEl = document.getElementById("timer");
  let intervalId = null;

  function format(totalSeconds) {
    if (totalSeconds < 0) totalSeconds = 0;

    const m = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const s = String(totalSeconds % 60).padStart(2, "0");

    return `Reserved for: <strong>${m}</strong> Mins : <strong>${s}</strong> Sec`;
  }


  function getEnd() {
    const v = localStorage.getItem(STORAGE_KEY);
    if (!v) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  function setEnd(ts) {
    localStorage.setItem(STORAGE_KEY, String(ts));
  }

  function clearEnd() {
    localStorage.removeItem(STORAGE_KEY);
  }

  function tick() {
    const end = getEnd();
    if (!end) {
      timerEl.innerHTML = format(DURATION);
      return;
    }

    const remaining = Math.ceil((end - Date.now()) / 1000);

    if (remaining <= 0) {
      timerEl.innerHTML = "Reserved for: 00 Mins : 00 Sec";
      clearEnd();
      clearInterval(intervalId);
      return;
    }

    timerEl.innerHTML = format(remaining);
  }

  function startTimer() {
    const existing = getEnd();

    if (!existing || existing <= Date.now()) {
      const endTs = Date.now() + DURATION * 1000;
      setEnd(endTs);
    }

    tick();
    intervalId = setInterval(tick, 500);
  }

  // sincronizar entre pestañas
  window.addEventListener("storage", tick);

  // iniciar al cargar
  startTimer();
})();
